import $ from 'jquery';
import { buildSlider } from '../utils/slider';

export default $pull_quotes => {
    $pull_quotes.each((i, el) => {
        const $slider = $(el).find('.pull-quotes__slider');
        const $logo_btns = $(el).find('.pull-quotes__logos__btn');
        const $arrows = $(el).find('.pull-quotes__content__arrows');
        const arrowHTML =
            '<button class="pull-quotes__content__btn"><span class="icon-arrow-rounded-left"></span></button>';

        buildSlider($slider, {
            slidesToShow: 1,
            slidesToScroll: 1,
            fade: true,
            dots: false,
            arrows: true,
            adaptiveHeight: true,
            appendArrows: $arrows,
            prevArrow: arrowHTML,
            nextArrow: arrowHTML,
        });

        $logo_btns.on('click', function() {
            const slideNum = parseInt($(this).attr('data-slide-num'));
            $slider.slick('slickGoTo', slideNum);
        });
    });
};
